export default {
    clearArray: function (array) {
        array.splice(0, array.length);
    },

    setDefaultCursor: function (elementId) {
        var id = elementId;
        if (id === undefined) {
            id = 'main';
        }
        document.getElementById(id).style.cursor = 'default';
    },

    setWaitCursor: function (elementId) {
        var id = elementId;
        if (id === undefined) {
            id = 'main';
        }
        document.getElementById(id).style.cursor = 'wait';
    },

    setVisible: function (id) {
        const element = document.getElementById(id);
        if (element) {
            element.style.visibility = 'visible';
        }
    },

    setHidden: function (id) {
        const element = document.getElementById(id);
        if (element) {
            element.style.visibility = 'hidden';
        }
    },

    fadeout: function (id, delay, callback) {
        var element = document.getElementById(id);
        if (element) {
            element.style.visibility = 'visible';
            element.style.opacity = 1;
            setTimeout(function() {
                var intervalID = setInterval(function () {
                    if (element.style.opacity > 0) {
                        element.style.opacity -= 0.01;
                    } else {
                        clearInterval(intervalID);
                        if (callback !== undefined) {
                            setTimeout(function() { callback() }, 1000);
                        }
                    }
                }, 50);
            }, delay);
        }
    },

    unique: function (array) {
        function isSelf(value, index, self) {
            return self.indexOf(value) === index;
        }
        return array.filter(isSelf);
    },

    wildcardMatch: function(pattern, str) {
        if (pattern && str) {
            const regexPattern = new RegExp('^.*' + pattern.toLowerCase().replace(/[-/\\^$+?.()|[\]{}]/g, '\\$&').replace(/\*/g, '.*') + '.*$');
            return regexPattern.test(str.toLowerCase());
        }
        else {
            return false;
        }
    }
}